"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Thumbnails = Thumbnails;
var React = require("react");
var sok_ui_1 = require("@caddigital/sok-ui");
require("./style.scss");
var classNames = require("classnames");
var openFile = function (file, target, preview) {
    if (target === void 0) { target = '_blank'; }
    if (preview === void 0) { preview = true; }
    return window.open("".concat(__UPLOADSERVERURL__, "/files/").concat(file.uuid).concat(preview === true ? '?preview=true' : ''), target);
};
var filterImages = function (file) { return file.type === 'IMAGE'; };
var DEFAULT_ITEMS_PER_ROW = {
    DESKTOP: 5,
    TABLET: 3,
    MOBILE: 1
};
var getEmpties = function (itemsLength, size, itemsPerRow) {
    var itemCount = itemsPerRow[size] || DEFAULT_ITEMS_PER_ROW[size];
    if (itemsLength % itemCount > 0) {
        var empties = [];
        for (var i = 0; i < itemCount - (itemsLength % 5); i++) {
            empties.push(React.createElement("div", { className: "sok-thumbnail sok-thumbnail-empty" }));
        }
        return empties;
    }
};
function Thumbnails(props) {
    var _a = props.onOpen, onOpen = _a === void 0 ? function (file) { return openFile(file); } : _a, _b = props.onDownload, onDownload = _b === void 0 ? function (file) {
        return openFile(file, '_self', false);
    } : _b, _c = props.onEdit, onEdit = _c === void 0 ? false : _c, _d = props.onDelete, onDelete = _d === void 0 ? false : _d, _e = props.size, size = _e === void 0 ? 'DESKTOP' : _e, _f = props.itemsPerRow, itemsPerRow = _f === void 0 ? DEFAULT_ITEMS_PER_ROW : _f, _g = props.localizationPrefix, localizationPrefix = _g === void 0 ? undefined : _g;
    return (React.createElement("div", { className: classNames('sok-thumbnails', "sok-thumbnails-".concat(size.toLowerCase())) },
        props.items.filter(filterImages).map(function (file, i) { return (React.createElement(sok_ui_1.Thumbnail, { key: "thumbnail-".concat(file.id, "-").concat(i), localizationPrefix: localizationPrefix, imageSrc: "".concat(__UPLOADSERVERURL__, "/files/").concat(file.uuid, "?preview=true"), onOpen: onOpen === false ? undefined : function () { return onOpen(file); }, onDownload: onDownload === false ? undefined : function () { return onDownload(file); }, onEdit: onEdit === false ? undefined : function () { return onEdit(file); }, onDelete: onDelete === false ? undefined : function () { return onDelete(file); }, isMobile: size === 'MOBILE' })); }),
        getEmpties(props.items.length, size, itemsPerRow)));
}
